export const DURATION = 1200;
